import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logo.svg';
const _withScopeId = n => (_pushScopeId("data-v-1db679de"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_2 = {
  class: "nav"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-split"
}, null, -1));
const _hoisted_4 = {
  class: "nav-cont"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "q-menu"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  class: "q-menu-item-child-links"
};
const _hoisted_13 = ["onClick"];
import { ref, reactive, watch } from 'vue';
import { getUrllink } from '@/api';
import navList from './nav-m';
import { useRouter } from 'vue-router';
export default {
  __name: 'mobileNav',
  setup(__props) {
    const basePath = window.appConfig.VUE_APP_PATH;
    const curent = ref(null);
    const navlist = reactive(navList);
    const menuClass = ref('');
    const visible = ref(false);
    // 移动端相关逻辑
    const toggleMenu = () => {
      menuClass.value = menuClass.value === '' ? 'open' : '';
      visible.value = !visible.value;
    };
    const closeMenu = () => {
      menuClass.value = '';
      visible.value = false;
    };
    const goPage = async url => {
      const link = await getUrllink();
      location.href = link;
    };
    const router = useRouter();
    const openItem = (item, list = navlist) => {
      if (item.url) {
        if (item.openurl) {
          window.open(item.url);
        } else {
          router.push(item.url);
        }
        toggleMenu();
      }
      list.forEach(itemi => {
        if (itemi.label !== item.label) {
          itemi.active = false;
          itemi.child && itemi.child.forEach(child => {
            child.active = false;
          });
        }
      });
      item.active = !item.active;
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_a_drawer = _resolveComponent("a-drawer");
      const _directive_track = _resolveDirective("track");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["header-m", menuClass.value])
      }, [_createVNode(_component_router_link, {
        to: _unref(basePath),
        class: "h-logo",
        onClick: _cache[0] || (_cache[0] = $event => closeMenu())
      }, {
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      }, 8, ["to"]), _createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("a", {
        href: "javascript:;",
        class: "login",
        onClick: _cache[1] || (_cache[1] = $event => goPage('loginUrl'))
      }, [_createTextVNode("登录/注册")])), [[_directive_track, {
        button_name: '登录/注册',
        click_info: '顶部导航栏_登录/注册',
        event_source: '顶部导航',
        event_source_pam: null,
        event_target: '亲笔签登录页',
        event_target_pam: null
      }]]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "nav-triggle",
        onClick: _cache[2] || (_cache[2] = $event => toggleMenu())
      }, _hoisted_6), _createVNode(_component_a_drawer, {
        class: "nav-drawer",
        placement: "top",
        closable: false,
        visible: visible.value,
        height: "85%",
        style: {
          'box-shadow': 0
        },
        onClose: toggleMenu
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navlist, item => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["q-menu-item", {
              is_active: item.active && item.child && item.child.length
            }])
          }, [_createElementVNode("div", {
            class: "q-menu-item-link",
            onClick: $event => openItem(item)
          }, [_createTextVNode(_toDisplayString(item.label), 1), item.child && item.child.length ? (_openBlock(), _createElementBlock("i", _hoisted_9)) : _createCommentVNode("", true)], 8, _hoisted_8), item.child && item.child.length ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(item.child, child => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["q-menu-item-child", {
                is_active: child.active
              }])
            }, [_createElementVNode("div", {
              class: "q-menu-item-child-head",
              onClick: $event => openItem(child, item.child)
            }, [_createTextVNode(_toDisplayString(child.label), 1), child.child && child.child.length ? (_openBlock(), _createElementBlock("i", _hoisted_11)) : _createCommentVNode("", true)], 8, _hoisted_10), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.child, link => {
              return _openBlock(), _createElementBlock("div", {
                class: "q-menu-item-link",
                onClick: $event => openItem(link)
              }, _toDisplayString(link.label), 9, _hoisted_13);
            }), 256))])], 2);
          }), 256)) : _createCommentVNode("", true)], 2);
        }), 256))])]),
        _: 1
      }, 8, ["visible"])])])], 2);
    };
  }
};